function stripTrailingSlash(str) {
    if (str.endsWith("/")) {
        return str.substr(0, str.length - 1);
    }
    else {
        return str;
    }
}

function getCookie (name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


function updateSwitchSiteButtonLink() {
    const bar_link_a = document.getElementById("libi-announcement-bar__link-a");

    const current_path = window.location.pathname;
    const query_params = window.location.search;

    const destination_website = stripTrailingSlash(bar_link_a.href);

    const discount_code = getCookie("discount_code");

    if (discount_code) {
        const query_params_with_redirect = 
            query_params === "" ? "?redirect=" : (query_params + "&redirect=");

        bar_link_a.href = destination_website + "/discount/" + discount_code + query_params_with_redirect + current_path;
        console.log("HERE - " + bar_link_a.href);
    }
    else {
        bar_link_a.href = destination_website +  current_path + query_params;
    }
}

document.addEventListener("DOMContentLoaded", updateSwitchSiteButtonLink);